import script from "./product-form.vue?vue&type=script&setup=true&lang=js"
export * from "./product-form.vue?vue&type=script&setup=true&lang=js"

import "./product-form.vue?vue&type=style&index=0&id=fe937f76&lang=less"

const __exports__ = script;

export default __exports__